<template>
  <div id="app">
    <v-app>
      <div class="loadingOverlay" v-if="isDataLoading">
        <v-progress-circular
        :size="50"
        indeterminate
        ></v-progress-circular>
      </div>
      <router-view />
    </v-app>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { getWizardId, saveWizardId,  saveLocationId} from '@/services/questionnaire.service';
import * as questionnaireService from '@/services/questionnaire.service';

export default {
  name: 'App',
  components: {
  },
  data: () => ({
    isDataLoading: true
  }),
  async created(){
 
    if(this.$route.query.locationId!=null){
      saveLocationId(this.$route.query.locationId);
    }
 
    if(this.$route.query.lwi!=null){
      saveWizardId(this.$route.query.lwi)
      this.getLeadWizard(this.$route.query.lwi)
    }
    else{
      let wizardId=getWizardId()
      if(wizardId==null){
        this.getLeadWizard(1)
      }
      else{
        this.getLeadWizard(getWizardId())
      }
    }
    if(this.$route.query.isBackOfficeApp&& this.$route.query.isBackOfficeApp=='1'){
      questionnaireService.destroyLeadId()
      questionnaireService.destroyPageId()
      questionnaireService.destroyWizardId()
    }
    if(this.$route.query.campaignId!=null || this.$route.query.leadSource!=null){
      this.questionnaireLead.CampaignId = this.$route.query.campaignId
      this.questionnaireLead.LeadSource = this.$route.query.leadSource
      this.mutateLead(this.questionnaireLead);
    }
    if(this.$route.query.mode!=null&& !isNaN(parseInt(this.$route.query.mode))){
      this.updateMode(parseInt(this.$route.query.mode))
    }

    if(this.$route.query.lwi!=null || this.$route.query.mode){
      this.$router.push(this.$route.path)
    }
  },
  methods:{
    ...mapActions(['getLeadWizard', 'getLocationId', 'updateMode','mutateLead']),
    checkDataLoaded() {
      if(Object.keys(this.curLeadWizard) !== 0) {
        this.isDataLoading = false
      }
    }
  },
  mounted(){
    this.$root.$on("updatingDataStarted", ()=>{
      this.isDataLoading = true
    });
    this.$root.$on("updatingDataEnded", ()=>{
      this.isDataLoading = false
    });
  },
  computed: {
    ...mapGetters(['questionnaireLead','curLeadWizard']),
  },
  watch:{
    curLeadWizard(){
      this.checkDataLoaded()
    },
  }
}
</script>

<style lang="scss">
@import '~@/styles/variables';
@import '~@/styles/base';

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.loadingOverlay{
  left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
    background: rgba(255,255,255,0.5);
    div{
      color: $loading-cirlce-color !important;
    }
}
html{
  overflow-y: auto;
}
</style>
